import projectFilterForm from "./project_filters/main";

export default {
  project_filter_form: projectFilterForm,
};
